import {Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-password-input',
  imports: [
    MatFormField,
    MatInput,
    MatIconButton,
    MatIcon,
    MatSuffix,
    ReactiveFormsModule,
    MatLabel,
    MatError,
  ],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.scss'
})
export class PasswordInputComponent implements OnInit {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() control: FormControl = new FormControl();
  @Input() hideRequiredMarker: boolean = false;
  @Input() autocomplete: 'off' | 'on' | '' = '';
  @Input() classes: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  hide: WritableSignal<boolean> = signal(true);

  constructor() {
  }

  ngOnInit(): void {
    this.control.valueChanges.subscribe((value: any) => {
      this.valueChange.emit(value)
    });
  }

  toggleVisibility(event: MouseEvent): void {
    //prevent default action
    event?.preventDefault();
    this.hide.set(!this.hide());
  }

}
